var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gb-flag_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 25756",
    width: 12,
    height: 12,
    rx: 6,
    transform: "translate(2830 847.608)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2830 -847.608)",
    clipPath: "url(#gb-flag_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "gb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39950",
    d: "M2830 847.843h11.765v11.765H2830z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39951",
    d: "M2841.765 847.843v1.471l-4.365 4.412 4.366 4.3v1.586h-1.54l-4.389-4.324-4.274 4.32H2830v-1.565l4.274-4.3-4.274-4.2v-1.7h1.425l4.412 4.32 4.274-4.32z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39952",
    d: "M2834.228 855.288l.253.781-3.516 3.539H2830v-.065zm2.849-.276l1.241.184 3.447 3.378v1.034zm4.688-7.169l-4.412 4.5-.092-1.007 3.447-3.493zm-11.765.023l4.435 4.343-1.356-.184-3.079-3.056z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39953",
    d: "M2834.044 847.843v11.765h3.677v-11.765zm-4.044 4.044v3.677h11.765v-3.677z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39954",
    d: "M2830 852.623v2.205h11.765v-2.205zm4.78-4.78v11.765h2.205v-11.765z"
  })))));
}
export default SvgGbFlag;